import { Link } from 'react-router-dom'

const TermsOfServicePage = () => {
  return (
    <div className='max-w-3xl mx-auto p-6 text-base text-left'>
      <h1 className='text-3xl font-bold mb-6'>Terms of Service</h1>
      <p className='text-sm text-gray-500 mb-6'>Last updated: March 28, 2026</p>

      <p className='mb-4'>
        These Terms of Service ("Terms") govern your use of the Inspire Health Tech Self-Service platform operated by Inspire Health Tech ("we", "our", "us"). By accessing or using the service, you agree to be bound by these Terms.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Use of Service</h2>
      <p className='mb-4'>
        The service is provided for authorized users to manage API keys, tokens, and view usage analytics. You agree to use the service only for its intended purpose and in compliance with all applicable laws.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Account Responsibilities</h2>
      <ul className='list-disc ml-6 mb-4 space-y-1'>
        <li>You are responsible for maintaining the confidentiality of your account credentials</li>
        <li>You must not share API keys or access tokens with unauthorized parties</li>
        <li>You agree to notify us immediately of any unauthorized use of your account</li>
        <li>You are responsible for all activity that occurs under your account</li>
      </ul>

      <h2 className='text-xl font-bold mt-6 mb-2'>API Usage</h2>
      <p className='mb-4'>
        API access is subject to rate limits and usage plans as defined by your service agreement. Excessive or abusive use may result in throttling or suspension of access.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Intellectual Property</h2>
      <p className='mb-4'>
        All content, features, and functionality of the service are owned by Inspire Health Tech and are protected by applicable intellectual property laws. You may not copy, modify, or distribute any part of the service without prior written consent.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Limitation of Liability</h2>
      <p className='mb-4'>
        The service is provided "as is" without warranties of any kind. To the fullest extent permitted by law, Inspire Health Tech shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Termination</h2>
      <p className='mb-4'>
        We reserve the right to suspend or terminate your access to the service at any time, with or without cause, and with or without notice.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Changes to These Terms</h2>
      <p className='mb-4'>
        We may revise these Terms at any time. Continued use of the service after changes constitutes acceptance of the revised Terms.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Contact Us</h2>
      <p className='mb-4'>
        If you have questions about these Terms, please contact us at <a href='mailto:support@inspireht.com' className='text-blue-6 hover:underline'>support@inspireht.com</a>.
      </p>

      <div className='mt-8 pt-4 border-t text-sm'>
        <Link to='/privacy' className='text-blue-6 hover:underline'>Privacy Policy</Link>
        <span className='mx-2'>·</span>
        <Link to='/' className='text-blue-6 hover:underline'>Back to Home</Link>
      </div>
    </div>
  )
}

export default TermsOfServicePage
